import React from 'react';
import { ChefProfile, Profile } from '../interface';
import ChefProfiles from './ChefProfiles';
import PartnerProfiles from './PartnerProfiles';

type PartnersProps = (
  | {
      partners: ChefProfile[];
      sectionHeader: string;
      type: 'chef';
    }
  | {
      partners: Profile[];
      type: 'partner';
    }
) & {
  showMobileView?: boolean;
};

const Partners: React.FC<PartnersProps> = (props) => {
  const { partners, type, showMobileView = false } = props;

  if (type === 'chef') {
    const { sectionHeader } = props;
    // Pass anchorId logic to ChefProfiles
    return (
      <ChefProfiles
        partners={partners}
        sectionHeader={sectionHeader}
        showMobileView={showMobileView}
      />
    );
  }

  // For partners, pass anchorId logic to PartnerProfiles
  return (
    <PartnerProfiles partners={partners} showMobileView={showMobileView} />
  );
};

export default Partners;
